export class UnauthenticatedError extends Error {
    constructor(message) {
        super(message);
    }
}
